// removed by extract-text-webpack-plugin
module.exports = {"container":"_3Pmtk"};


//////////////////
// WEBPACK FOOTER
// ./app/components/login-to-comment/login-to-comment.scss
// module id = 1734
// module chunks = 0